import React from 'react';
import classnames from 'classnames';
import styles from './label.css';

export interface LabelProps {
  /** Adds additional classes to the component. */
  className?: string;
  /** Provides visual elements for usage on a dark environment */
  darkEnv?: boolean;
  /** Content of the link */
  children: string | JSX.Element;
  /** Declares the id attribute of the associated input element of the label */
  htmlFor?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Label component
 *
 * @param {LabelProps} props
 *
 * @returns JSX.ELEMENT
 */
export const Label = ({
  className,
  htmlFor,
  darkEnv,
  children,
  'data-testid': dataTestId
}: LabelProps) => {
  const labelClasses = classnames(styles.label, className, {
    [styles.dark]: darkEnv
  });

  return (
    <label className={labelClasses} htmlFor={htmlFor} data-testid={dataTestId}>
      {children}
    </label>
  );
};

export default Label;
